import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47535364"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-black grid w-[100vw] h-[100vh] justify-items-center overflow-hidden video-wrapper" }
const _hoisted_2 = {
  style: {"display":"none"},
  ref: "canva"
}
const _hoisted_3 = {
  for: "gallery",
  class: "cursor-pointer switch-button z-10 rounded-[100%] bg-gray-200 w-[6vh] h-[6vh] items-center grid justify-center text-black hover:bg-gray-600 mt-[20vh]"
}
const _hoisted_4 = { class: "photo-button-container z-10 w-[100vw] h-[10vh] flex justify-center" }
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = ["src", "alt"]

import {onMounted, ref} from "vue";
  import { Camera, SwitchCamera, SaveAll, X, Folder } from 'lucide-vue-next'
  import {useRoute} from "vue-router";
  import {Button} from "@/components/ui/button";
  import router from "@/router";
  import {Card, CardContent} from "@/components/ui/card";
  import {Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious} from "@/components/ui/carousel";
  import TablesService from "@/services/tables/tables.service";
  import {toast} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";
  import {Input} from "@/components/ui/input";
  import Spinner from "@/components/ui_custom/spinner/Spinner.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Camera',
  setup(__props) {

  const photos: any = ref([]);
  let mediaStream: any = ref(null);
  let videoDevices: any = ref([])
  let facingMode: any = ref("environment")
  const counter = ref(0)
  let switchingCamera = ref(false)
  const route = useRoute();
  const id = route.params.id;
  const entity = route.params.entity;
  let serviceOrderId: any = '';
  let isLoading = ref(false);
  if (route.params.serviceOrderId) {
    serviceOrderId = route.params.serviceOrderId;
  }

  async function startRecording(FacingMode: any) {
    facingMode = FacingMode;
    let video: any = document.querySelector('video');
    mediaStream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: facingMode },
    });
    video.srcObject = mediaStream;
    return await video.play();
  }

  async function takePhoto() {
    let video: any = document.querySelector('video');
    let canvas: any = document.querySelector('canvas');

    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    let ctx = canvas.getContext("2d");

    if (facingMode.value === "user") {
      ctx.scale(-1, 1);
      ctx.drawImage(video, video.width * -1, 0, video.width, video.height);
    } else {
      ctx.drawImage(video, 0, 0);
    }
    const dataUrl = canvas.toDataURL("image/jpg");
    const blob = dataURLToBlob(dataUrl)

    photos.value.push({
      id: counter.value++,
      src: dataUrl,
      originalname: 'blob',
      entityId: id,
      entity: entity,
      file: blob
    });
  }

  async function submitPhotos() {
    isLoading.value = true;
    const formData = new FormData();
    formData.append('entity', entity.toString());
    formData.append('entityId', id.toString());
    formData.append('serviceOrderId', serviceOrderId.toString());
    photos.value.forEach(function (photo: any) {
      formData.append('files', photo.file, photo.originalname);
    })
    const res = await TablesService.createBulkAttachments(formData, 'attachments')
    if (res?.data.statusCode === 200) {
      toast.success(i18n.global.t('toast.insert_success'));
      router.back();
    }
    isLoading.value = false;
  }

  function dataURLToBlob(dataUrl: any) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  async function switchCamera() {
    switchingCamera.value = true;
    if (mediaStream.value) {
      const tracks = mediaStream.value.getVideoTracks();
      tracks.forEach((track: any) => {
        track.stop();
      });
    }
    await startRecording(
        facingMode.value === "environment" ? "environment" : "user"
    );
    switchingCamera.value = false;
  }

  function removePhoto(id: any) {
    photos.value = photos.value.filter((obj: any) => obj.id !== id)
  }

  function upload(): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<void>(async (resolve, reject) => {
      const filePicker = document.querySelector('input');

      if (!filePicker || !filePicker.files
          || filePicker.files.length <= 0) {
        reject('No file selected.');
        return;
      }

      const fileArray: any = filePicker.files;
      for (const file of fileArray) {
        const base64File = await convert(file);
        const blob = dataURLToBlob(base64File);
        photos.value.push({
          id: counter.value++,
          src: base64File,
          entityId: id,
          entity: entity,
          originalname: file.name,
          file: blob
        });
      }
    });
  }

  function convert(myFile: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const fileReader = new FileReader();
      if (fileReader && myFile) {
        fileReader.readAsDataURL(myFile);
        fileReader.onload = () => {
          resolve(fileReader.result as any);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        reject('No file provided');
      }
    });
  }

  onMounted(async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    videoDevices.value = devices.filter((d) => d.kind === "videoinput");
    await startRecording(
        videoDevices.value.length === 1 ? "user" : "environment"
    )
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Spinner, { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("video", {
        class: _normalizeClass(["h-[100%] video z-0", _unref(facingMode) === 'user' ? 'front' : '']),
        ref: "video"
      }, null, 2),
      _createElementVNode("canvas", _hoisted_2, null, 512),
      _createVNode(_unref(Button), {
        class: "switch-button z-10 rounded-[100%] bg-gray-200 w-[6vh] h-[6vh] items-center justify-center text-black hover:bg-gray-600",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(X), { class: "h-6 w-6" })
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "switch-button z-10 rounded-[100%] bg-gray-200 w-[6vh] h-[6vh] items-center grid justify-center text-black hover:bg-gray-600 mt-[10vh]",
        onClick: switchCamera
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SwitchCamera), { class: "h-6 w-6" })
        ]),
        _: 1
      }),
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_unref(Folder), { class: "h-6 w-6" })
      ]),
      _createElementVNode("input", {
        id: "gallery",
        type: "file",
        multiple: "",
        class: "hidden",
        onChange: upload
      }, null, 32),
      _createVNode(_unref(Button), {
        class: "switch-button z-10 rounded-[100%] bg-gray-200 w-[6vh] h-[6vh] items-center justify-center text-black hover:bg-gray-600 mt-[30vh]",
        onClick: submitPhotos,
        disabled: photos.value.length === 0
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SaveAll), { class: "h-6 w-6" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Button), {
          class: "bg-gray-200 w-[8vh] h-[8vh] rounded-[100%] items-center grid justify-center text-black hover:bg-gray-600",
          onClick: takePhoto
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Camera), { class: "h-10 w-10" })
          ]),
          _: 1
        })
      ]),
      (photos.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(Carousel), {
            key: 0,
            class: "relative w-[43%]",
            opts: { align: 'start' }
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CarouselContent), { class: "-ml-1" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
                    return (_openBlock(), _createBlock(_unref(CarouselItem), {
                      key: photo.id,
                      class: "pl-1 md:basis-1/2 lg:basis-1/3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(Card), { class: "bg-black border-black" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Button), {
                                    class: "absolute p-2 rounded-full bg-gray-200 text-red-700",
                                    onClick: _withModifiers(($event: any) => (removePhoto(photo.id)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(X), { class: "w-5 h-5" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createElementVNode("img", {
                                    src: photo.src,
                                    alt: photo.id,
                                    class: "w-full"
                                  }, null, 8, _hoisted_6)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_unref(CarouselPrevious)),
              _createVNode(_unref(CarouselNext))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})